"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Autocomplete = _interopRequireWildcard(require("@mui/material/Autocomplete"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Autocomplete = props => {
  const {
    defaultOptionId,
    ignoreAccents,
    ignoreCase,
    label,
    limit,
    matchFrom,
    onChange,
    options,
    stringify,
    trim
  } = props;
  const filterOptions = (0, _Autocomplete.createFilterOptions)({
    ignoreAccents,
    ignoreCase,
    limit,
    matchFrom,
    stringify,
    trim
  });

  /** A hook to fire "onChange" for a default value */
  (0, _react.useEffect)(() => {
    if (defaultOptionId) {
      const defaultOption = options.find(prd => prd.id === defaultOptionId);
      if (defaultOption) onChange(null, defaultOption);
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Autocomplete.default, {
    defaultValue: options.find(opt => opt.id === defaultOptionId) ?? undefined,
    filterOptions: filterOptions,
    onChange: onChange,
    options: options,
    renderInput: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      ...params,
      label: label
    })
  });
};
Autocomplete.propTypes = {
  defaultOptionId: _propTypes.default.number,
  ignoreAccents: _propTypes.default.bool,
  ignoreCase: _propTypes.default.bool,
  label: _propTypes.default.string,
  limit: _propTypes.default.number,
  matchFrom: _propTypes.default.oneOf(["any", "start"]),
  onChange: _propTypes.default.func,
  options: _propTypes.default.array,
  stringify: _propTypes.default.func
};
Autocomplete.defaultProps = {
  ignoreAccents: true,
  ignoreCase: true,
  limit: 50,
  matchFrom: "any",
  options: [],
  trim: true
};
var _default = exports.default = Autocomplete;